module.exports = "<div [@animMask]=\"showMask\" class=\"mask\" *ngIf=\"showMask\" (click)=\"onClose($event)\"></div>\r\n"